<div class="main-info">
  <div class="main-info__header">
    <div class="main-info__title">
      {{ 'app.components.courseCreator.settings.mainInfo.title' | translate }}
    </div>
  </div>
  <div class="main-info__content">
    @if (showTopic()) {
      <div class="main-info__field main-info__field--topic">
        <label class="main-info__topic-label" for="course-topic-input">{{
          'app.components.courseCreator.settings.mainInfo.topic.label' | translate
        }}</label>
        <textarea
          id="course-topic-input"
          class="main-info__topic-input"
          rows="3"
          [placeholder]="
            'app.components.courseCreator.settings.mainInfo.topic.placeholder' | translate
          "
          [value]="topicText()"
          (input)="onTopicInput($any($event.target).value)"
        ></textarea>
      </div>
    }
    @for (field of fields(); track field.id) {
      <div class="main-info__field">
        <div class="main-info__field-wrapper">
          <div class="main-info__field-container">
            <app-form-field
              [field]="field"
              [options]="getOptionsForField(field.id)"
              (valueChange)="onSelectionChange($event)"
              (customValueChange)="onCustomValueChange($event)"
            />
          </div>
        </div>
      </div>
    }
  </div>
</div>
